<template>
    <div id="serviceWrap" >
        <!-- <div class="fixedIconBox" @click="toForm">
            <span class="titleText">服务申请</span>
        </div>
        <img src="../../images/service/service_02.jpg" alt="" @click="toForm" />
        <img src="../../images/service/service_03.jpg" alt="" />
        <img src="../../images/service/service_04.jpg" alt="" />
        <img src="../../images/service/service_05.jpg" alt="" />
        <div class="longBtnBox">
            <button class="btn-red btn-long btn-shadow" @click="toForm">服务申请</button>
        </div> -->
        <div class="fixedIconBox" @click="toForm">
            <span class="titleText">服务申请</span>
        </div>
        <div class="firstSection">
            <div class="backBtn" @click="back"  v-if="!isFromYjj">
                <i class="el-icon-arrow-left"></i> 返回
            </div>
            <img src="../../images/newImages/bg_peitaochanyefuwu.png" alt="">
            <div class="floatBox">
                <div class="title bold">配套产业服务</div>
                <div class="subtitle">设计、生产、营销、数据全面贯通，企业运作效率全面提升</div>
                <div class="btnBox">
                    <button class="btn-red" @click="toForm">服务申请</button>
                </div>
            </div>
        
        </div>
        <div class="textSection">
            <p class="liangduanduiqi">浙江省服装产业创新服务综合体联合中国联通、华为、阿里云、珞珈数据共同建设以数据驱动为核心的开放、共享的服装产业互联网PAAS平台，链接设计师平台、版师平台、中央版房数据中心、面辅料采购平台、智能制造系统、仓储物流及销售信息平台等SAAS应用服务；为服装产业提供一体化的产业信息化服务，任何企业都可通过使用其一项SAAS应用系统，从而与产业上下游贯通。</p>
        </div>
        <div class="tuwenBlock">
            <div class="title">
                <img src="../../images/newImages/ic_hezuodanwei.png" alt="">
                战略合作单位</div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/companyLogo/01.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="contentText">深圳市昱辰泰克科技有限公司，是一家专业的生产过程控制（MES）系统解决方案供应商、产品制造商和服务提供商。</div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/companyLogo/02.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="contentText">杭州海诚服装设备公司是一家提供制衣成套设备和智能自动化设备的大型专业公司，以销售全球最为先进的服装制作成套设备为特色，帮助工厂进行智能化改造。</div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/companyLogo/03.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="contentText">广州市罗斯泰克科技有限公司是全球化时尚行业ERP解决方案提供商，专业为企业用户提供全面的一站式企业信息化解决方案。</div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/companyLogo/04.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="contentText">  杭州凯普森科技有限公司凭借18的经验一直专注于服装研发部门的软件开发与创新，帮助多家品牌女装企业完成小单快反项目改造。</div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/companyLogo/05.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="contentText">宁波圣瑞思工业自动化有限公司是一家专业经营纺织服装悬挂系统、自动化物流运输系统等专业设备的企业，公司集研发、生产、销售、工程施工、管理培训于一体。</div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/companyLogo/06.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="contentText">杭州慕创科技有限公司是一家致力于移动终端，给服饰及其相关行业带来营销、管理的全方位服务。</div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/companyLogo/07.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="contentText">上海秒优信息科技有限公司致力于为服装行业提供有效的管理解决方案。</div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/companyLogo/08.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="contentText">杭州欣如智能科技有限公司主要从事物联网软硬件及网络设备的技术咨询、技术开发、技术服务、技术应用，以及物联网软硬件产品、电子标签的销售。</div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/companyLogo/09.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="contentText">广州衣布到位信息科技有限公司致力完成供应链闭环的建设，是纺织服装供应链全服务平台，为处于纺织服装供应链各个环节的企业搭建对接交易桥梁。</div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/companyLogo/10.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="contentText">杭州得体科技有限公司以大数据为基础，构建SaaS技术系统，深度整合服装产业上下游资源，提供“低成本+快反应+多款式的原创设计”的新型供应链服务（S2B）。</div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/companyLogo/11.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="contentText">上海设界商务信息咨询有限公司为时尚产业创造者提供从趋势灵感到供应链到能力培育到展示发布的（OMO）联合空间。是以产业服务驱动园区运营的互联网科技平台。</div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/companyLogo/12.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="contentText">深圳穿针引线科技有限公司旗下互联网平台穿针引线网自2001年开始为服装行业爱好者学习交流。</div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/companyLogo/13.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="contentText">广州亿澳斯软件股份有限公司拥有世界先进的供应链优化技术,在亚洲服装制造领域垂直深入应用长达十年，建立了亚洲制衣业供应链数字化管理流程的标准。</div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/companyLogo/14.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="contentText">杭州嘉图信息科技有限公司旗下网站好订单网专注于纺织服装产业供应链，立足于纺织服装行业生产与贸易的协同，构建优质高效的行业商圈。</div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/companyLogo/15.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="contentText">杭州服邦信息科技有限公司旗下产品浙江服装圈，是集招聘、求职、找单、外发、工银等于一体的信息共享平台，为服装人工作开展提供便利。</div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/companyLogo/16.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="contentText">杭州果敢科技有限公司是涵盖品牌化电商运营业务、电商直播业务、数据服务的综合性平台企业。打造出一系列红人ip，形成了垂直细分化电商业务布局。</div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/companyLogo/17.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="contentText">杭州布调科技有限公司以数码印染为核心的产业互联网平台及数码印染众创园区。</div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/companyLogo/18.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="contentText">杭州珞珈数据科技有限公司，是由美国海归资深科学家和工程师创建的一家跨国大数据专业公司。</div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/companyLogo/19.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="contentText">微辣网红电商公司是一家以网红运营、网红孵化、网红学院为核心的深度运营公司，拥有10000平方以上的办公室面积，荣获多项殊荣。</div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/companyLogo/20.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="contentText">广州采多多信息科技有限公司，是一个利用互联网技术，集合电商、金融、物流等服务手段，对细分行业的上下游产业链进行深度垂直化整合的移动互联网电商平台。</div>
                </div>
            </div>
        </div>
        <div class="bottomImg">
            <img src="../../images/newImages/img_logo_dibu.png" alt="" class="footImg">
        
        </div>
    </div>
</template>

<script>
    import {
        ajaxCode,
        ajaxLogin
    } from '@/assets/request.js'
    import {
        setCookie,
        phoneReg,
        codeReg,
        filterPhoneNum,
        GetRequest
    } from '@/assets/common.js'
    export default {
        data() {
            return {
                paramObj: {},
                phone: '',
                code: '',
                isFromYjj:'',
            }
        },
        methods: {
            back(){
              this.$router.back()  
            },
            toForm() {
                this.$router.push({
                    name: 'ServiceForm'
                });
            },
            login() {
                let _this = this
                ajaxLogin(_this.phone, _this.code).then(res => {

                    let token = JSON.parse(res.data).token
                    let userId = JSON.parse(res.data).userId
                    console.log(token, userId)
                    sessionStorage.setItem("isLogined", "1")
                    sessionStorage.setItem("token", token)
                    sessionStorage.setItem("userId", userId)
                    setCookie("global_token", token, 10)
                }, (res) => {})
            }
        },
        mounted() {
           this.paramObj = GetRequest()
           console.log(this.paramObj )
           this.phone = this.paramObj.p
           this.code = this.paramObj.c
           if (this.phone && this.code) {
               this.login()
           }
           this.isFromYjj=this.code?true:false
           console.log(this.isFromYjj,'是否来自衣加加')
        }
    }
</script>

<style lang="less" scoped="scoped">
    img {
        width: 100%;
    }
    #serviceWrap{
        .firstSection{
            position: relative; color:#fff;
            .floatBox{
                position: absolute; top:1.9rem; left:0.4rem;
                .title{
                    font-size: 0.48rem;font-weight: bold; line-height: 0.67rem;
                }
                .subtitle{font-size: 0.28rem;line-height: 0.38rem; width: 4rem;margin-top: 0.15rem;}
                .btnBox{
                    button{
                        position: absolute; top:0.7rem;right:-2.5rem;
                        padding:0.21rem 0; width: 1.97rem;font-size: 0.28rem;
                    }
                }
            }
        }
        .textSection{
            font-size: 0.36rem; color:#333; line-height: 0.68rem;padding:0.8rem 0.44rem; background: #fff;
        }
        .tuwenBlock{
            margin-top: 0.4rem; background: #fff;
            padding:0rem 0.4rem; padding-bottom: 0.8rem;
            .title{
                font-size: 0.3rem; font-weight: bold;line-height: 0.5rem; text-align: center; padding:0.92rem 0;
                img{width: 0.74rem;}
            }
            .tuwenOne{
                background: #fff; padding:0rem 0.32rem; display: flex; margin-bottom: 0.4rem; 
                .leftImg{
                    display: flex; align-items: center;
                    .img{
                        width: 1.6rem; height:1.5rem;
                    }
                }
                .rightText{
                    padding-left:0.73rem;
                    .contentText{font-size: 0.28rem;color:#000; line-height: 0.4rem;text-align: justify}
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/introPage/service.vue